<template>
<div class="row">
	<div class="col-2 col-xs-2 col-md-2 col-lg-1 col-xl-1 text-center" style="font-size:40px">
		<fa-icon style="color:333" icon="plus-circle" v-if="index == 0 && form.status != 'O' && form.status != 'C'"  />
		<fa-icon style="color:#dc3545" icon="times-circle" v-if="index == 0 && form.status == 'C'"  />
		<fa-icon style="color:#777" icon="arrow-alt-circle-up" v-if="index > 0"   />
		<fa-icon style="color:green" icon="check-circle" v-if="index == 0 && form.status == 'O'"   />
	</div>

	<div class="col-10 col-xs-10 col-md-10 col-lg-11 col-xl-11">
		<div :style="{'color': index == 0 ? '#333' : '#777' }">
			<fa-icon style="margin-top: -3px" v-if="item.idUsuarioResponsavel != 0" icon="user-cog" />
			<fa-icon style="margin-top: -3px" v-if="item.idUsuarioResponsavel == 0" icon="user" />
			{{item.nomeUsuario}} em {{item._data}}
		</div>

		<hr />

		<span class="reset-p" v-html="item.descricao"></span>

		<div style="margin-top: 10px; margin-bottom:20px" v-if="item.anexo.length > 0">
			<div>Anexos:</div>
			<div v-for="(anexo, idxAnw) in item.anexo"  :key="idxAnw">
				<a class="badge badge-light" :href="'tickets/' + form.codigo + '/' + anexo.nomeArquivoHash" target="_blank">{{anexo.nomeArquivo}}</a><br/>
			</div>
		</div>
	</div>

	<div class="col-md-12">
		<hr />
	</div>
</div>
</template>

<script>
export default {
	props: ['form', 'index', 'item']
}
</script>


<style lang="scss" scoped>
.reset-p {
	p {
		margin: 0rem!important;
		margin-bottom: 0rem !important;
		padding: 0rem !important;
		line-height: 1rem !important;
	}
}
</style>



// WEBPACK FOOTER //
// src/views/ticket/time-line.vue